const templateUrl = require('./toast.html');

module.exports = {
  templateUrl: templateUrl,
  bindings: {
    toast: '<ogFor'
  }
};
